import { z } from 'zod';
export const ebaySiteIdSchema = z.enum([
    'EBAY_US',
    'EBAY_GB',
    'EBAY_DE',
    'EBAY_AU',
    'EBAY_CA',
    'EBAY_FR',
    'EBAY_IT',
    'EBAY_ES',
]);
export const ebayConditionCodeSchema = z.union([
    z.literal(1000),
    z.literal(1500),
    z.literal(3000),
    z.literal(4000),
    z.literal(5000),
    z.literal(6000),
]);
export const ebayListingTypeSchema = z.enum(['AUCTION', 'FIXED_PRICE']);
export const ebayDurationSchema = z.enum([
    'DAYS_3',
    'DAYS_5',
    'DAYS_7',
    'DAYS_10',
    'GTC',
]);
export const createEbayListingSchema = z.object({
    itemId: z.string().uuid(),
    siteId: ebaySiteIdSchema,
    title: z.string().min(1).max(80),
    description: z.string().min(1).max(500000),
    condition: ebayConditionCodeSchema,
    categoryId: z.string().min(1),
    imageUrls: z.array(z.string().url()).optional(),
    listingType: ebayListingTypeSchema,
    startingPrice: z.number().positive().optional(),
    buyItNowPrice: z.number().positive().optional(),
    duration: ebayDurationSchema,
    itemSpecifics: z.record(z.string(), z.string()).optional(),
}).refine((data) => {
    if (data.listingType === 'AUCTION') {
        return data.startingPrice !== undefined && data.startingPrice > 0;
    }
    if (data.listingType === 'FIXED_PRICE') {
        return data.buyItNowPrice !== undefined && data.buyItNowPrice > 0;
    }
    return true;
}, {
    message: 'Auction requires starting price, Fixed Price requires buy it now price',
});
export const ebayCallbackSchema = z.object({
    code: z.string().min(1),
    state: z.string().min(1),
});
export const ebayCategorySearchSchema = z.object({
    siteId: ebaySiteIdSchema,
    query: z.string().min(1).max(100),
});
//# sourceMappingURL=ebay.js.map